<template>
  <div>
    <div class="head">
      <el-breadcrumb style="margin-top: 8px;margin-left:20px" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>今日值班人员</el-breadcrumb-item>
        <el-breadcrumb-item>查询</el-breadcrumb-item>
      </el-breadcrumb>
      <el-button type="primary" v-if="$route.query.status" size="small" @click="$router.go(-1)">返回</el-button>
    </div>
    <div class="content">
      <div style="display:flex;justify-content: space-between">
      <!-- <div class="block">
        <el-date-picker
          v-model="value3"
          size="small"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </div> -->
      <div>
        <Input search enter-button placeholder="请输入名称或者电话" v-model="searchContent" @on-search='searchBtn' />
      </div>
      <el-button type="primary" size="small" @click="$router.push('JrzbAdd')">新增</el-button>
    </div>
    <div class="tableBox">
      <Table :columns="columns1" :data="data1">
        <template slot-scope="{row}" slot="showTime">
          {{row.showTimeStart}} 至 {{ row.showTimeEnd }}
        </template>
        <template slot-scope="{row}" slot="leader">
          <Tag color="default" v-for="(item1,index1) in row.dutyLeader" :key="index1">
            {{ item1.name }}<Icon type="ios-call-outline" size="16" />{{ item1.number }}
          </Tag>
        </template>
        <template slot-scope="{row}" slot="dutyOfficer">
          <Tag color='default' v-for="(item2,index) in row.dutyEmployees" :key="index">{{ item2.name }}</Tag>
        </template>
        <template slot-scope="{row}" slot="operation">
          <span class="editBtn" @click="editBtn(row)">编辑</span>
          <span class="line">|</span>
          <span class="removeBtn" @click="removeBtn(row.id)">删除</span>
        </template>
      </Table>
      <div class="page"><Page :total="total" :page-size='limit' :current='curPage' @on-change="curPageChange" /></div>
    </div>
    </div>
  </div>
</template>

<script>
import { getJrzbList, removeJrzbData } from '@/api/processHome'
export default {
  name: 'JrzbSearch',
  data() {
    return {
      searchContent: '',
      columns1: [
        {
          title: '时间',
          key: 'gmtCreate',
          minWidth: 100
        },
        {
          title: '展示时间',
          slot: 'showTime',
          minWidth: 200
        },
        {
          title: '值班领导',
          slot: 'leader'
        },
        {
          title: '值班人员',
          slot: 'dutyOfficer',
        },
        {
          title: '创建者',
          key: 'founder'
        },
        {
          title: '操作',
          slot: 'operation',
          align: 'center',
          minWidth: 100
        }
      ],
      data1: [], // 表格的数据
      total: 0,
      limit: 10,
      curPage: 1
    }
  },
  created() {
    // 进入页面时获取表格
    this.getList()
  },
  methods:{
    // 搜索按钮
    searchBtn() {
      this.getList()
    },
    // 获取列表
    getList() {
      getJrzbList({search: this.searchContent, limit: this.limit, curPage: this.curPage}).then(res => {
        let arr = res.body.data
        arr.forEach(item => {
          item.dutyEmployees = JSON.parse(item.dutyEmployees)
          item.dutyLeader = JSON.parse(item.dutyLeader)
        })
        this.data1 = res.body.data
        this.total = res.body.cum
      })
    },
    // 分页
    curPageChange(val) {
      this.curPage = val
      this.getList()
    },
    // 编辑
    editBtn(val) {
      this.$router.push(
        {
          path: 'JrzbAdd',
          query: {...val}
        }
      )
    },
    // 删除
    removeBtn(val) {
      this.$confirm('确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(() => {
        removeJrzbData(val).then(res => {
          if(this.data1.length <= 1 && this.curPage > 1) {
            this.curPage -= 1
          }
          this.getList()
          this.$message.success('删除成功')
        })
      })
    }
  }
}
</script>

<style scoped>
.head {
  display: flex;
  justify-content: space-between;
}
.editBtn {
  cursor: pointer;
  color: rgb(22,143,237);
}
.line {
  margin: 0 10px;
  color: #e8e8e8;
  font-weight: 100
}
.removeBtn {
  cursor: pointer;
  color: red;
}
.tableBox {
  margin-top: 15px;
}
.tableBox /deep/ .ivu-table-row {
  height: 75px;
}
.page {
  text-align: right;
  margin-top: 15px
}
</style>